import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ENVIRONMENT from '../../../../environments';
import { Row, Col, Button,notification ,Tabs,Card} from 'antd';
import SaveCardFlow from '../SaveCardFlow';
import SuccessModal from '../../SuccessModal/SuccessModal';
import WarningModal from '../../WarningModal/WarningModal';
import CustomerMainLayout from '../CustomerMainLayout';
import ShowCardFlow from '../ShowCarfFlow/ShowCardFlow';
import SubscriptionPlanDetails from '../SubscriptionPlansDetails/SubscriptionPlansDetails';
import './AccountDetails.scss'
import CustomerOnboarding from '../CustomerOnboarding';
import CompanyProfile from '../CompanyProfile/CompanyProfile';
import FileConstants from '../../../../FileConstants';
import GroupManagement from '../GroupManagement/GroupManagement';
import SubscriptionUsageDetails from '../SubscriptionUsageDetails/SubscriptionUsageDetails';
import InAppPurchasesDetails from '../InAppPurchasesDetails/InAppPurchasesDetails';
import Profile from '../Profile/Profile';
import CompanyUsers from '../CompanyUsers';

const { TabPane } = Tabs;
const COMPANY_ID = localStorage.getItem('company_id');

const TABS = {
    "1": "billing",
    "2": "",
    "3": "group",
    "4": "subs",
    "5": "payment",
    "6": "profile",
    "7": "company-users"
}
const openNotification = placement => {
    notification.info({
      message: 'Deleted!',
      description:
        'Your card has been removed from the system, you can now enter information for a new card.',
      placement,
    });
  };

const AccountDetails = (props) => {
   
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [loading, setLoading] = useState(true);
    const [cardSaveSuccess, setCardSaveSucces] = useState(false);
    const [cardStatus, setCardStatus] = useState(null);
    const [cardSaveFailure, setCardSaveFailure] = useState(false);
    const [userInformation, setUserInformation] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [defaultActiveKey, setDefaultActiveKey] = useState("1");
    let tour_step = new URLSearchParams(window.location.search).get("step_no");
    let payment_redirected = new URLSearchParams(window.location.search).get("payment_redirected");

    useEffect(() => {
        console.log('REDIRECTION ATTRIBYTE',payment_redirected);
        // Check if card was just saved from sessionStorage
        const cardJustSaved = sessionStorage.getItem('cardJustSaved');
        if (payment_redirected || cardJustSaved === 'true') {
            setCardSaveSucces(true);
            if (cardJustSaved === 'true') {
                sessionStorage.removeItem('cardJustSaved');
            }
        }
        loadUserPaymentType();
    },[]);
  
    const loadUserPaymentType = (callback = undefined) => {
        let payload = {
          "username": localStorage.getItem('username'),
          "action": "getinfo"
        }
        axios.post(ENVIRONMENT.GET_USER_PAYMENT_INFORMATION, payload)
        .then(res => {
            setUserInformation(res.data['card_information'])
            setCardStatus(res.data['card_status']);
            if (callback != undefined) {
                callback();
            }
        });
      }

    const deleteUserPaymentType = () => {
        let payload = {
            "username": localStorage.getItem('username'),
            "action": "delete"
          }
        axios.post(ENVIRONMENT.GET_USER_PAYMENT_INFORMATION, payload)
        .then(res => {
            setUserInformation(res.data['card_information'])
            setCardStatus(res.data['card_status']);
            loadUserPaymentType(() => setOpenModal(false));
            openNotification('topRight');
            window.location.reload()
        });
    }

    const updateUserAccountInformation = (payload) => {
        setUserInformation(payload['card_information'])
        setCardStatus(payload['card_status']);
    }

    useEffect(() => {
        let tab = (new URL(window.location.href)).searchParams.get("tab");
        if (tab == "subs" || tour_step == '4') {
            setDefaultActiveKey("4");
        } else if (tab == "group") {
            setDefaultActiveKey("3");
        } else if (tab == "profile") {
            setDefaultActiveKey("6");
        } else if (tab == "billing") {
            setDefaultActiveKey("1");
        } else if (tab == "payment") {
            setDefaultActiveKey("5");
        } else if (tab == "company-users") {
            setDefaultActiveKey("7");
        } else {
            setDefaultActiveKey("1");
        }
        
    }, []);

      const changeTab = (key) => {
        setDefaultActiveKey(key);
        const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?tab=' + TABS[key];
        window.history.pushState({path: newurl},'', newurl);
      }

    
    return (
          <CustomerMainLayout selected={defaultActiveKey == 7 ? '33' : null}>
                
            <Row className="justify-space-between" style={{marginTop:"30px",marginBottom: 32}}>
                <Col>
                    <div className='manrope f-24 w-600 black-085' style={{display:'flex',alignItems:"flex-end"}}>
                        Account Settings
                    </div>
                </Col>
            </Row>
            
            <Tabs bordered={false} onChange={changeTab} style={{padding:"10px"}} defaultActiveKey={defaultActiveKey} activeKey={defaultActiveKey}  >
                {/* {localStorage.getItem('company_id') &&
                <TabPane tab="Profile Settings" key={"1"}>
                    <CompanyProfile/>
                </TabPane>} */}
                 <TabPane tab="Current Plan" key={"4"}>
                    <SubscriptionUsageDetails updateUserAccountInformation={updateUserAccountInformation}/>
                </TabPane>
                <TabPane tab="Profile" key={"6"}>
                   <Profile/>
                </TabPane>
                {localStorage.getItem('user_role') == 'admin' && 
                <>
                <TabPane tab="Billing Info" key={"1"}>
                    <Row>
                        {cardStatus == 0 ?
                        <Col span={16}>
                                <h2 className="manrope f-16 black-14" style={{marginBottom: 28}}>Credit Card Information</h2>
                                <SaveCardFlow account_details_form={true} setCardSaveFailure={setCardSaveFailure}/>
                            </Col>:                     
                            cardStatus == 1 ? <ShowCardFlow 
                                deleteUserPaymentType={deleteUserPaymentType}
                                userInformation={userInformation}
                                openModal={openModal}
                                setOpenModal={setOpenModal}
                                /> : ''
                            }
                    </Row>  
                </TabPane>
             
                <TabPane tab="Payment History" key={"5"}>
                    <InAppPurchasesDetails />
                </TabPane>
                </>}
                {/* <TabPane tab="Groups" key={"3"}>
                    <GroupManagement />
                </TabPane> */}
                <TabPane tab="Users" key={"7"}>
                    <CompanyUsers />
                </TabPane>
            </Tabs>

            
            <SuccessModal
            visible={cardSaveSuccess}
            heading={"Card Saved Successfully"}
            text={"Your card has been successfully saved!"}
            footer={[
            <div className="justify-in-center">
                <Button style={{margin:"auto"}} className="modal-okay square font-14" htmlType="submit" onClick={() => {
                    setCardSaveSucces(false);}}>
                    Okay
                </Button>
            </div>
            ]}/>
        
            <WarningModal
            visible={cardSaveFailure}
            onCancel={() => setCardSaveFailure(false)}
            heading={"Unable to Save Card"}
            text={"We are very sorry but we were unable to save your card. Please try again."}
            footer={[
            <div className="justify-in-end">
                <Button key="back" style={{textAlign:"center"}} className="modal-okay square font-14" onClick={() => setCardSaveFailure(false)}>
                    Okay
                </Button>
            </div>
            ]}/>
            
            {tour_step ?
            <CustomerOnboarding/>
            :
            ""    
            }
        </CustomerMainLayout>
      );

}

export default AccountDetails;
  